/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires on input focus (an input field becomes active and gets a cursor)
 */
export interface InputFocus {
  /**
   * name that identifies the field
   */
  fieldName: string;
  /**
   * the type of the field
   */
  fieldType:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'switch'
    | 'tel'
    | 'text'
    | 'textarea';
}

export const inputFocus = (data: Readonly<InputFocus>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'input_focus', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/input_focus/jsonschema/1-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
